{
  "version": 1,
  "asset_id": "7d2057c1-7ec4-47d7-8a48-405938462263",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/7d2057c1-7ec4-47d7-8a48-405938462263/sleeve-normal-revision-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/7d2057c1-7ec4-47d7-8a48-405938462263/sleeve-normal-revision-800.webp",
  "original_filename": "sleeve-normal-revision-800.webp",
  "size": 54424,
  "content_type": "image/webp",
  "created_at": "2026-10-05T01:21:42Z"
}
